import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import ResourceInfoPopover from '../../common/ResourceInfoPopover';
import { RESOURCE_LABEL } from '../../common/constants';
import UnsavedChangesWarning from '../../common/UnsavedChangesWarning';
import MssDelete from '../../common/MssDelete';
import Loader from '../../common/Loader';
import useDeleteFlashcardDeck from './useDeleteFlashcardDeck';

function EditDeckHeader({ deck, isLoading, isDirty, isSaveDisabled, onSave, onDeleted, savedAt }) {
  const courseId = useSelector((state) => state.course.courseId);

  // Where a deleted deck leaves the learner is the page's to say: it holds the
  // unsaved-changes guard, and leaving has to release it.
  const { deckToDelete, isDeleting, promptDelete, cancelDelete, deleteDeck } =
    useDeleteFlashcardDeck({ courseId, onDeleted });

  return (
    <>
      <Box className="resourceHeader" id="editDeck__box_header">
        <Box className="resourceTitleGroup">
          <Box className="resourceTitle">
            <Typography variant="h2" component="h1">
              Edit Flashcard Deck
            </Typography>
            <ResourceInfoPopover
              id="editDeck__button_info"
              name={deck.title}
              nameLabel={RESOURCE_LABEL.FLASHCARD_DECK}
              resources={deck.resources}
              lastEditedBy={deck.lastEditedBy}
              instructions='Click text to edit. Changes will not be saved until "Save" button is clicked.'
            />
          </Box>
        </Box>

        <Box className="resourceActions resourceActions--stack">
          <UnsavedChangesWarning isDirty={isDirty} savedAt={savedAt} />
          <Button
            variant="contained"
            className="mss__button"
            id="editDeck__button_deleteDeck"
            disabled={isLoading}
            onClick={() => promptDelete(deck)}
          >
            Delete Deck
          </Button>
          <Button
            variant="contained"
            className="mss__button primary"
            id="editDeck__button_save"
            disabled={isSaveDisabled}
            onClick={onSave}
          >
            Save
          </Button>
        </Box>
      </Box>

      <Loader id="editDeck__loader_deleting" isOpen={isDeleting} />
      {deckToDelete && (
        <MssDelete
          id="editDeck__modal_confirmDelete"
          onToggle={cancelDelete}
          onDelete={deleteDeck}
          title="Delete Flashcard Deck"
          resourceName={deckToDelete.title}
          isLoading={isDeleting}
          maxWidth="sm"
        />
      )}
    </>
  );
}

export default EditDeckHeader;
